export const IS_LIVE = process.env.IS_LIVE === 'true';
export const IS_SECONDARY = process.env.IS_SECONDARY === 'true';